import { TravellerAction, TravellerActions } from './../actions/traveller.actions';
import { IntercityStop, ProductGroup, Product, ProductCategory } from '@ridango/core';
import { Action } from 'redux';
import { tassign } from 'tassign';



export interface TravellersState {
    all: any[];
    categoryIds: any[];
    categories: any;
    selectedCategoryId: any;
    selectedCategoryObj: ProductCategory;
}

export const TRAVELLERS_INITIAL_STATE: TravellersState = {
    all: [],
    categoryIds: [],
    categories: [],
    selectedCategoryId: null,
    selectedCategoryObj: null
};


export function travellersReducer ( lastState: TravellersState = TRAVELLERS_INITIAL_STATE, action: TravellerAction ): TravellersState {
    switch ( action.type ) {
        case TravellerActions.FETCH_START:
            return lastState;
        case TravellerActions.FETCH_SUCCESS:
            return tassign( lastState );
        case TravellerActions.FETCH_FAILED:
            return lastState;
        case TravellerActions.FETCH_END:
            return lastState;
        case TravellerActions.SET_TRAVELLER_CATEGORIES:
            return tassign( lastState, {
                all: action.payload.all,
                categoryIds: action.payload.categoryIds,
                categories: action.payload.categories
            } );
        case TravellerActions.SET_ALL_TRAVELLER_CATEGORIES:
            return tassign( lastState, { all: action.payload } );
        case TravellerActions.SET_TRAVELLER_CATEGORY:
            return tassign( lastState, { selectedCategoryId: action.payload } );
        case TravellerActions.SET_TRAVELLER_CATEGORY_OBJ:
            return tassign(lastState, { selectedCategoryObj: action.payload });
        case TravellerActions.CLEAR_TRAVELLER:
            return tassign(lastState, TRAVELLERS_INITIAL_STATE);
    }

    // We don't care about any other actions right now.
    return lastState;
}
// return { count: lastState.count + 1 };
